// The closed set of `eligibility_check_fields` patterns a paying org can use,
// mirroring Sparta's `EligibilityCheckFields` enum
// (`sparta/src/eligibility/types/eligibilityCheckFields.ts`). An org's value
// drives the eligibility entry screen, the check payload shape, and the
// not-eligible routing — so the strings are centralized here rather than
// repeated as literals across the rules engine + screens.
export const ELIGIBILITY_CHECK_FIELDS = {
  FN_LN_DOB: 'FN_LN_DOB',
  FN_LN_DOB_OR_EMPID_DOB: 'FN_LN_DOB_OR_EMPID_DOB',
  FN_LN_DOB_EMPID: 'FN_LN_DOB_EMPID',
  FN_LN_DOB_EMPID_EMAIL_GENDER: 'FN_LN_DOB_EMPID_EMAIL_GENDER',
  FN_LN_DOB_AND_EMPID_OR_ZC: 'FN_LN_DOB_AND_EMPID_OR_ZC',
} as const;

export type EligibilityCheckField =
  (typeof ELIGIBILITY_CHECK_FIELDS)[keyof typeof ELIGIBILITY_CHECK_FIELDS];
